import React from 'react';
import { Outlet } from 'react-router-dom';
import HeaderComponent from '../components/Header';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/LoadingSpinner';

type Props = {
  allowPublic?: boolean;
};

const BasicLayout: React.FC<Props> = ({ allowPublic }) => {
  const { loading } = useAuth();

  if (!allowPublic && loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="container">
      <HeaderComponent fixButtons={allowPublic} />
      <div className="main">
        <div className="centered-content">
          <div className="centered-div">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicLayout;
